import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Device, DeviceState } from '@era/locations-sdk';
import { Observable } from 'rxjs';
import { DeviceStoreSelectors } from '@era/stores';
import { DevicesUnassignedBadgeComponent } from './devices-unassigned-badge.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-devices-unassigned-badge',
  templateUrl: './devices-unassigned-badge.container.html',
  styleUrls: ['./devices-unassigned-badge.container.scss'],
  imports: [DevicesUnassignedBadgeComponent, AsyncPipe],
})
export class DevicesUnassignedBadgeContainerComponent {
  public readonly count$: Observable<number>;

  constructor(private readonly store: Store<Device>) {
    this.count$ = this.store.select(DeviceStoreSelectors.selectDevicesCountByState(DeviceState.Unassigned));
  }
}
